import Vue from "vue";
import "@vue-components/helpers/vue-filters.js";
import "@vue-components/helpers/vue-directives.js";
import "./vue-cms-directives.js";
import "@vue-components/helpers/vue-mixin.js"
import {getLocale} from "@vue-components/helpers/I18nPluginHelper.js";
import PermissionHelper from "@vue-components/helpers/PermissionHelper.js";

Vue.mixin({
    computed: {
        displayMode() {
            return this.$store.state.displayMode;
        },
        previewMode: {
            get() {
                return this.$store.state.previewMode;
            },
            set(value) {
                this.$store.state.previewMode = value;
            }
        },
        isWheelchairMode() {
            return this.$store.state.accessibility.wheelchair;
        },
        isKioskDevice() {
            return this.$store.state.displayMode === `kiosk`;
        },
        isMobileDevice() {
            return this.$store.state.displayMode === `mobile` || this.$store.state.previewMode === `mobile`;
        },
        isAndroidDevice() {
            return /Android/i.test(navigator.userAgent);
        },
        isiOSDevice() {
            return /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === `MacIntel` && navigator.maxTouchPoints > 1);
        },
        isTabletDevice() {
            return this.$store.state.displayMode === `tablet` || this.$store.state.previewMode === `tablet`;
        },
        isDesktopDevice() {
            return this.$store.state.displayMode === `desktop`;
        },
        isMobileLayoutOrPreview() {
            return this.$store.state.isMobileLayout || this.$store.state.previewMode === `mobile`;
        },
        isTabletLayoutOrPreview() {
            return this.$store.state.isTabletLayout || this.$store.state.previewMode === `tablet`;
        },
        isMobileOrTabletLayoutOrPreview() {
            return this.$store.state.isMobileOrTabletLayout || this.$store.state.previewMode === `mobile` || this.$store.state.previewMode === `tablet`;
        },
        dealerid() {
            return this.$store.state.website?.dealerid;
        },
        cms() {
            return this.$store.state.cms;
        },
        cmsItems() {
            return this.$store.state.cms.items;
        },
        cmsTypes() {
            return this.$store.state.cms.types;
        },
        // Removed / replaced with cmsWebsite
        // website() {
        //     return this.$store.state.website;
        // },
        cmsWebsite() {
            return this.$store.state.website;
        },
        cmsLocales() {
            return this.$store.state.website.settings.languages;
        },
        cmsPage() {
            return this.$store.state.page;
        },
        // cmsPageItem() {
        //     if (this.$store.state.page) {
        //         return this.$store.state.cms.getFirstItemByType(this.$store.state.page.itemType);
        //     } else {
        //         return null;
        //     }
        // },
        cmsPages() {
            if (this.$store.state.website) {
                return this.$store.state.website.pages;
            } else {
                return [];
            }
        },
        isEditMode() {
            return this.$store.state.editMode;
        },
        isDisplayingReview() {
            return this.$store.state.display.review && this.isEditMode;
        },
        fontAwesomePrefix() {
            return this.$store.state.website.design.fontAwesome.prefix;
        },
        displayLanguage() {
            if (this.$store.state.previewLanguage) {
                return this.$store.state.previewLanguage;
            } else {
                return getLocale();
            }
        }
    },
    methods: {
        canRead(permission) {
            return PermissionHelper.can(`read`, permission);
        },
        canWrite(permission) {
            return PermissionHelper.can(`write`, permission);
        },
        canAdmin(permission) {
            return PermissionHelper.can(`admin`, permission);
        },
        canAdminEyeInWireless() {
            return PermissionHelper.can(`admin`, null, `Eye-In Wireless`);
        },
        isDealerParent() {
            return this.canAdminEyeInWireless();
        },
        isIPad() {
            const ua = window.navigator.userAgent;
            const platform = window.navigator.platform;
            const maxTouchPoints = window.navigator.maxTouchPoints || 0;

            return (/iPad/.test(ua) || (platform === "MacIntel" && maxTouchPoints > 1));
        },
    }
});

export default {};
